import script from "./PageLayout.vue?vue&type=script&lang=ts&setup=true"
export * from "./PageLayout.vue?vue&type=script&lang=ts&setup=true"

import "./PageLayout.vue?vue&type=style&index=0&id=4643cf2e&lang=css"

const __exports__ = script;

export default __exports__